import { SelectOwnProps } from ".";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Box, styled, Typography } from "@mui/material";

export type SelectProps = SelectOwnProps &
  React.ComponentProps<typeof TextField>;

const CssTextField = styled(TextField)<{ customize?: boolean }>(
  ({ customize }) => ({
    // Filled Input
    "& .MuiFilledInput-root": {
      backgroundColor: "#FFFFFF",
      borderRadius: "12px",
      /* yelo-usernext's field border, the same line the design fields
         (DesignFieldRedux) draw, so MUI and design fields match. */
      border: "1px solid #ddd6df",
    },
    "& .MuiFilledInput-root:after, .MuiFilledInput-root:before": {
      display: "none",
    },
    "& .MuiInputBase-root.MuiFilledInput-root.Mui-disabled": {
      backgroundColor: "#ececec",
      opacity: "0.5",
    },
    // "& .MuiFilledInput-root .Mui-disabled": {
    //   backgroundColor: "#ececec",
    //   opacity: "0.5",
    // },
    "& .Mui-focused": {
      backgroundColor: "#FFFFFF !important",
    },
    "& .MuiFilledInput-input:hover": {
      borderRadius: "12px",
      backgroundColor: "#FFFFFF !important",
    },
    "& .MuiFilledInput-root .MuiSelect-select": {
      padding: customize ? "25px 12px 8px 12px" : "24px 32px 8px 12px",
    },
  })
);

export default function Select({
  options = [],
  customize,
  StartIcon,
  StartIconProps,
  placeholder,
  ...rest
}: SelectProps) {
  const renderValue = (selected: any) => {
    const found = options.find((o) => o.value === selected);
    if (found) return found.label;
    if (selected === "" || selected === undefined || selected === null) {
      return placeholder ? (
        <span className="yp-select-placeholder">{placeholder}</span>
      ) : (
        ""
      );
    }
    return selected;
  };

  return (
    <>
      {StartIcon ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#FFFFFF",
            paddingLeft: "10px",
            borderRadius: "4px",
          }}
        >
          <StartIcon style={{ fontSize: "18px", ...StartIconProps }} />
          {/* <img
            src={StartIcon}
            alt=""
            loading="lazy"
            style={{ maxWidth: "18px" }}
          /> */}
          <CssTextField
            select
            color="info"
            fullWidth
            variant="filled"
            SelectProps={{
              MenuProps: {
                /* Above AppModal (1400) and the full-screen sheets (1500) a select
                   can sit in: at MUI's default 1300 the list opened behind
                   them and the select seemed dead. */
                sx: { maxHeight: "300px", zIndex: 1600 },
                PaperProps: { className: "yp-select-menu-paper" },
              },
              displayEmpty: true,
              renderValue,
            }}
            {...rest}
          >
            {options.map(({ value, label }, index) => (
              <MenuItem className="yp-select-menu-item" key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </CssTextField>
        </Box>
      ) : (
        <>
          {customize && (
            <Typography
              mb={1}
              color={"#0a0a0e"}
              fontSize={"12px"}
              fontWeight={400}
              textTransform={"uppercase"}
            >
              {rest?.label}
            </Typography>
          )}
          <CssTextField
            color="info"
            select
            fullWidth
            customize
            variant="filled"
            SelectProps={{
              MenuProps: {
                /* Above AppModal (1400) and the full-screen sheets (1500) a select
                   can sit in: at MUI's default 1300 the list opened behind
                   them and the select seemed dead. */
                sx: { maxHeight: "300px", zIndex: 1600 },
                PaperProps: { className: "yp-select-menu-paper" },
              },
              displayEmpty: true,
              renderValue,
            }}
            {...rest}
            label={!customize ? rest.label : ""}
          >
            {options.map(({ value, label }, index) => (
              <MenuItem className="yp-select-menu-item" key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </CssTextField>
        </>
      )}
    </>
  );
}
